import { ApprovalDTO } from './approval-dto';
import { PageRowsResponseDTO } from './page-response-dto';

export interface ReadApprovalsResponseDTO extends PageRowsResponseDTO<ApprovalDTO> {}
